<template>
  <el-dialog
    title="付款调整确认"
    append-to-body
    :visible="dialogVisible"
    :close-on-click-modal="false"
    center
    width="80%"
    @close="closeDialog"
  >
    <div class="paymentDialog">
      <h3>付款调整</h3>
      <vxe-toolbar>
        <template v-slot:buttons>
          <vxe-button
            type="primary"
            class="vxe-btn-delete"
            @click="handleDelete('payTable')"
            :style="'background-color:' + '#FE8783' + ';border:1px solid ' + '#FE8783'"
            >删除</vxe-button
          >
          <vxe-button type="primary" class="vxe-btn-primary" @click="sure">确认</vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-table
        width="100%"
        align="left"
        show-header-overflow
        class="vxe-table-element"
        :auto-resize="true"
        border
        resizable
        show-overflow
        :data="paymentList"
        :edit-config="editConfig"
        size="mini"
        ref="payTable"
        :max-height="$store.state.app.tableHeight"
        :edit-rules="payTableEditRules"
      >
        <vxe-table-column type="checkbox" width="50"></vxe-table-column>
        <vxe-table-column width="150" field="instructionNo" title="发货指令编号"></vxe-table-column>
        <vxe-table-column
          width="150"
          field="purchaseContractNo"
          title="采购合同号"
        ></vxe-table-column>
        <vxe-table-column
          width="120"
          field="instructionStatusName"
          title="发货指令状态"
        ></vxe-table-column>
        <vxe-table-column width="120" field="partnerName" title="供应商名称"></vxe-table-column>
        <vxe-table-column width="120" field="deliverDate" title="发货日期"></vxe-table-column>
        <vxe-table-column width="120" field="salesmanName" title="业务员"></vxe-table-column>
        <vxe-table-column width="120" field="baseName" title="基地简称"></vxe-table-column>
        <vxe-table-column
          width="120"
          field="businessInboundBatchNo"
          title="入库批次号"
        ></vxe-table-column>
        <vxe-table-column width="120" field="carNo" title="车牌号"></vxe-table-column>
        <vxe-table-column width="120" field="netWeight" title="净重(吨)"></vxe-table-column>
        <vxe-table-column width="120" field="deduct" title="扣杂(吨)"></vxe-table-column>
        <vxe-table-column
          width="120"
          field="instructionNumber"
          title="供应商发货指令数量"
        ></vxe-table-column>
        <vxe-table-column
          width="120"
          field="businessVariablePrice"
          title="业务结算单价"
        ></vxe-table-column>
        <vxe-table-column
          width="120"
          field="businessVariablePriceWithTax"
          title="业务结算金额"
        ></vxe-table-column>
        <vxe-table-column width="120" field="taxRate" title="税率"></vxe-table-column>
        <vxe-table-column width="120" field="payStatusName" title="付款状态"></vxe-table-column>
        <vxe-table-column width="120" field="paidMoney" title="已付款金额"></vxe-table-column>
        <vxe-table-column width="120" field="unPaidMoney" title="未付款金额"></vxe-table-column>
        <vxe-table-column width="120" field="applyMoney" title="本次付款金额" :edit-render="{}">
          <template v-slot:edit="scope">
            <input-number
              :max="scope.row.unPaidMoney"
              v-model="scope.row.applyMoney"
              precision="2"
            ></input-number>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div v-if="showResult" style="margin-top: 20px">
        <h3>付款确认</h3>
        <vxe-table
          width="100%"
          align="left"
          show-header-overflow
          class="vxe-table-element"
          :auto-resize="true"
          border
          resizable
          show-overflow
          :data="resultData"
          size="mini"
          ref="resultTable"
          :max-height="$store.state.app.tableHeight"
        >
          <vxe-table-column type="seq" width="50" title="序号"></vxe-table-column>
          <vxe-table-column field="purchaseContractNo" title="采购合同号"></vxe-table-column>
          <vxe-table-column field="partnerName" title="供应商名称"></vxe-table-column>
          <vxe-table-column field="totalApplyPayMoney" title="本次付款金额"></vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="saveApply">确认申请</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import API from '@/api/wareHouse/supplierDeliveryOrder.js';
  export default {
    name: 'paymentDialog',
    props: ['dialogVisible', 'paymentList'],
    computed: {
      payTableEditRules() {
        return {
          applyMoney: [
            {
              required: true,
              message: '请输入金额',
              trigger: 'blur',
            },
          ],
        };
      },
    },
    data() {
      return {
        showResult: false,
        resultData: [],
        editConfig: { trigger: 'click', mode: 'row' },
      };
    },
    methods: {
      closeDialog() {
        this.$emit('close');
      },
      saveApply() {
        let listData = this.$refs.payTable.getTableData().fullData || [];
        console.log(listData, '11111111');
        if (listData.length === 0) {
          return this.$message({
            showClose: true,
            message: '暂无付款调整数据，不能确认付款申请',
            type: 'warning',
          });
        }
        if (this.resultData.length === 0 && !this.showResult) {
          return this.$message({
            showClose: true,
            message: '还未确认付款调整，不能确认付款申请',
            type: 'warning',
          });
        }
        console.log(this.resultData);
        const params = {
          detailApplyInfos: listData,
          mergeApplyInfos: this.resultData,
        };
        this.$axios.post(API.SAVE_BATCH_APPLY_INFO_API, params).then((res) => {
          console.log(res, '1111');
          if (res.data.code === 0) {
            const params = res.data.data || [];
            this.$axios.post(API.PAYMENT_APPLY_API, params).then((res) => {
              console.log(res, '222222');
              if (res.data.code === 0) {
                this.closeDialog();
                let path = {
                  path: '/payment/paymentApplyAdd',
                  name: 'paymentApplyAdd',
                  meta: {
                    keepAlive: true,
                    title: '付款申请单创建',
                  },
                  query: { isEdit: 'Y' },
                  params: res.data.data,
                };
                this.$store.dispatch('tagsView/addTabView', path).then(() => {
                  this.$nextTick(() => {
                    this.$router.push(path);
                  });
                });
              } else {
                this.$message('付款申请失败');
              }
            });
          } else {
            this.$message('付款申请失败');
          }
        });
      },
      sure() {
        console.log('sure');

        let tempArr = [];
        let listData = this.$refs.payTable.getTableData().fullData || [];
        let hasErrorStatus = false;
        listData.map((pay) => {
          if (!pay.applyMoney) {
            hasErrorStatus = true;
          }
          tempArr.push({
            purchaseContractNo: pay.purchaseContractNo,
            partnerName: pay.partnerName,
            totalApplyPayMoney: Number(pay.applyMoney),
            companyCode: pay.companyCode,
            companyName: pay.companyName,
            contractCurrency: pay.contractCurrency,
            contractCurrencyName: pay.contractCurrencyName,
            contractNo: pay.purchaseContractNo,
            departmentCode: pay.departmentCode,
            departmentName: pay.departmentName,
            partnerNo: pay.partnerNo,
            payBatchNo: pay.payBatchNo,
            projectInitiationNo: pay.projectInitiationNo,
            projectName: pay.projectName,
          });
        });
        if (hasErrorStatus) {
          return this.$message({
            showClose: true,
            message: '请填写本次付款金额',
            type: 'warning',
          });
        }
        this.editConfig = {};
        console.log(tempArr, 'tempArr');
        let newArr = tempArr.reduce((prev, cur) => {
          let purchaseContractNos = prev.map((item) => {
            return item.purchaseContractNo;
          });
          if (purchaseContractNos.includes(cur.purchaseContractNo)) {
            prev = prev.map((item) => {
              if (item.purchaseContractNo === cur.purchaseContractNo) {
                item.totalApplyPayMoney += Number(cur.totalApplyPayMoney);
              }
              return item;
            });
          } else {
            prev.push(cur);
          }
          return prev;
        }, []);
        console.log(newArr, '11111111');
        this.resultData = newArr.map((item) => {
          return {
            ...item,
            totalApplyPayMoney: Number(item.totalApplyPayMoney).toFixed(2),
          };
        });
        this.showResult = true;
      },
      // 删除选中表格
      handleDelete(tableType) {
        console.log(tableType, 'insertEvent');
        const selectedList = this.$refs[tableType].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('goods.message.noChooseDel'),
            type: 'error',
          });
          return;
        }
        this.$refs[tableType].removeSelecteds();
      },
    },
  };
</script>
